module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "memberinfo"
  }, [_c('div', {
    staticClass: "yue",
    on: {
      "click": _vm.wyue
    }
  }, [_vm._m(1), _c('div', [_vm._v("账户余额")]), _c('div', {
    staticClass: "sum"
  }, [_vm._v("￥500")])]), _vm._m(2)]), _c('div', {
    staticClass: "memberbox"
  }, [_vm._m(3), _c('div', {
    staticClass: "member-item",
    on: {
      "click": _vm.recharge
    }
  }, [_vm._m(4), _c('div', {
    staticClass: "m-title"
  }, [_vm._v("账户充值")]), _c('div', {
    staticClass: "m-desc"
  }, [_vm._v(" 9折")])]), _c('div', {
    staticClass: "member-item",
    on: {
      "click": _vm.userinfo
    }
  }, [_vm._m(5), _c('div', {
    staticClass: "m-title"
  }, [_vm._v("个人信息")]), _c('div', {
    staticClass: "m-desc"
  }, [_vm._v(" 9折  ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar-wrap"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": require(".././assets/avatar.png")
    }
  })]), _c('div', {
    staticClass: "username"
  }, [_vm._v("张三丰  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    staticStyle: {
      "transform": "scale(0.7)"
    },
    attrs: {
      "src": require(".././assets/yue.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jf"
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    staticStyle: {
      "transform": "scale(0.7)"
    },
    attrs: {
      "src": require(".././assets/jf.png")
    }
  })]), _c('div', [_vm._v("积分总计")]), _c('div', {
    staticClass: "sum"
  }, [_vm._v("500")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "member-item"
  }, [_c('div', {
    staticClass: "m-img",
    staticStyle: {
      "transform": "scale(0.7)"
    }
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/4.png")
    }
  })]), _c('div', {
    staticClass: "m-title"
  }, [_vm._v("等级折扣")]), _c('div', {
    staticClass: "m-desc"
  }, [_vm._v(" 9折")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-img",
    staticStyle: {
      "transform": "scale(0.7)"
    }
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/6.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-img",
    staticStyle: {
      "transform": "scale(0.7)"
    }
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/7.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3782e6ef","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/member.vue
// module id = 113
// module chunks = 0